export default __webpack_public_path__ + "static/media/char_body_prem_013.a130ff77.png";